import { render, staticRenderFns } from "./RemoveAllProductsModal.vue?vue&type=template&id=4ad8ea61&"
import script from "./RemoveAllProductsModal.vue?vue&type=script&lang=js&"
export * from "./RemoveAllProductsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports